export default {
  title: 'Complementos para mayor éxito',
  description: 'Mejora tu plan con funciones adicionales',
  buttons: {
    continue: 'Continuar',
    no_app_for_now: 'Sin aplicación móvil por ahora',
  },
  toasts: {
    something_went_wrong: 'Algo salió mal, intenta recargar la página o contacta con el soporte técnico.',
    failed_to_save_changes: 'No se pudieron guardar los cambios, contacta con el soporte técnico.',
    changes_got_saved: '¡Los cambios se guardaron correctamente!',
  },
};
